<template>
  <div
    :class="{
      'border-danger-50': data.type === 'danger',
      'border-primary-300': data.type === 'success',
      'border-orange-300': data.type === 'warning',
    }"
    class="cursor-default bg-white py-5 px-4 shadow-primary rounded-10px w-352px flex flex-col space-y-1 border">
    <template v-if="_title">
      <span
        class="text-lg font-bold"
        :class="{
          'text-danger-50': data.type === 'danger',
          'text-primary-300': data.type === 'success',
          'text-orange-300': data.type === 'warning',
        }"
      >
        {{_title}}
      </span>
    </template>
    <span class="text-base">{{data.text}}</span>
  </div>
</template>

<script>
export default {
  name: 'NotificationsToast',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    _title() {
      if (this.data.title) {
        return this.data.title;
      }
      if (this.data.type === 'danger') {
        return this.$t('errors.error');
      }
      return null;
    },
  },
};
</script>
